/**
 * useOutreachMailboxHealth — the CRM Overview's mailbox-health card
 * (GET /campaigns/{id}/outreach/mailbox-health). useOutreachSSE refreshes it
 * on every mailbox event; the poll keeps "sent today" moving while sends go
 * out without one.
 */
import { useQuery } from '@tanstack/react-query';
import type { OutreachMailboxHealth } from '@discovr/types';
import { campaignKeys } from '../queryKeys';
import { retryOutreachQuery } from './outreachRetry';
import { fetchOutreachMailboxHealth } from '../api/outreachApi';

const OUTREACH_MAILBOX_HEALTH_REFRESH_MS = 60_000;

export function useOutreachMailboxHealth(campaignId: string) {
  return useQuery<OutreachMailboxHealth>({
    queryKey: campaignKeys.outreachMailboxHealth(campaignId),
    queryFn: () => fetchOutreachMailboxHealth(campaignId),
    enabled: !!campaignId,
    staleTime: OUTREACH_MAILBOX_HEALTH_REFRESH_MS,
    refetchInterval: OUTREACH_MAILBOX_HEALTH_REFRESH_MS,
    retry: retryOutreachQuery,
  });
}
